module.exports = __webpack_public_path__ + "static/media/collectibles.ff4f1c3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/collectibles.svg
// module id = 3065
// module chunks = 0